module.exports = __webpack_public_path__ + "static/img/v_10.8bbb130d.png";